import React, { FC, useMemo } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useField } from "formik";
import { IFormField, ISelectOption } from "src/@types/form";
import { FormField } from ".";
import { Select } from "../Select";

export const SingleSelectField: FC<IFormField> = ({
  className,
  fieldClassName,
  labelClassName,
  id,
  label,
  variant,
  placeholder,
  errorClassName,
  options,
  ...props
}) => {
  const { t } = useTranslation();

  const fieldId = id || (props.name as string);

  const [{ value, ...field }, { error, touched }, { setValue, setTouched }] =
    useField<ISelectOption["value"]>(fieldId);

  const isShownError = Boolean((touched || value) && error);

  const onChange = ({ value }: ISelectOption) => {
    setValue(value);
  };

  const onBlur = () => setTouched(true);

  const placeholderText =
    typeof placeholder === "string"
      ? placeholder
      : placeholder && t(placeholder.i18nKey, placeholder.i18nParams);

  const activeValue = useMemo(() => {
    const activeValue = options.find((option) => option.value === value);
    return activeValue ? activeValue : null; // Important: return null, not undefined, to properly control the select value
  }, [options, value]);

  return (
    <FormField
      className={fieldClassName}
      labelClassName={labelClassName}
      variant={variant}
      label={label}
      labelFor={fieldId}
      isShownError={isShownError}
      error={error}
      errorClassName={errorClassName}
    >
      <Select
        {...props}
        {...field}
        id={fieldId}
        className={cn("w-full", className)}
        placeholder={placeholderText}
        value={activeValue}
        onChange={onChange}
        onBlur={onBlur}
        isMulti={false}
        options={options}
        // onKeyDown={onKeyDownEnter}
      />
    </FormField>
  );
};
